import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="toggle-submenu"
export default class extends Controller {
  static targets = ["submenu"];
  connect() {
    console.log("toggleSubmenuController connected");
  }

  toggle(event) {
    const clickedSubmenu = event.currentTarget.querySelector(
      '[data-toggle-submenu-target="submenu"]'
    );
    if (!clickedSubmenu) return;

    const wasActive = clickedSubmenu.classList.contains("active");
    this.submenuTargets.forEach((submenu) =>
      submenu.classList.remove("active")
    );
    if (!wasActive) clickedSubmenu.classList.add("active");
  }

  close(event) {
    if (!this.hasSubmenuTarget) return;
    if (!this.element.contains(event.target)) {
      this.submenuTargets.forEach((submenu) =>
        submenu.classList.remove("active")
      );
    }
  }
}
